/*
  fetch API:

  https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API

  whatwg-fetch : https://github.com/github/fetch

  import DataFetch from 'utils/data_fetch'
  let data = new DataFetch('http://local.dev.nexgate.com:3000/ui_hook/check');
  data.run().
  then(function (json) {
    console.log(['PING FOR SESSION 11: ', json])
  }).
  catch(function (ex) {
    console.log(['ERROR PING 11', ex])
  })
*/

import 'whatwg-fetch'
import Promise from 'promise-polyfill'
import to_querystring from 'querystring'
import SERVER_INFO from 'config/server_info'

if (!window.Promise) {
    window.Promise = Promise
}

export const createRequestConfig = function (url = null, with_credentials = false, method = null) {

    const headers_map = {'Content-Type': 'application/x-www-form-urlencoded'};

    if (method != 'GET') {
        const metaTag = document.querySelector('meta[name="csrf-token"]');
        if (metaTag != null) {
            headers_map["X-CSRF-Token"] = metaTag.content;
        }
    }

    const request_config = {
        headers: headers_map,
        credentials: 'include',
        mode: 'cors'
    }

    if(url != null) request_config['url'] = url;
    if(with_credentials) request_config['withCredentials'] = true;

    return request_config

}

class DataFetch {
    static run(url, params, method = 'GET', extra_options = {}) {
        let paths = url.split('/')
        let module = paths[0]== "" ? paths[1] : paths[0]  // accounts for urls starting with "/" or actual path TODO something nicer?
        let this_url = (module.endsWith('v2') ) 
            ? url.startsWith('/') 
                ? `${SERVER_INFO.main_v1_path}${url}` 
                : `${SERVER_INFO.main_v1_path}/${url}`
            : url

        const fetch_conf = createRequestConfig(this_url, true, method)

        if (method == 'POST' || method == 'PUT' || method == 'DELETE') {
            fetch_conf.method = method
            if(extra_options.multipart_form_data == true){
                fetch_conf.body = params;
                delete fetch_conf.headers['Content-Type']
            } else {
                fetch_conf.body = "json_payload=" + encodeURIComponent(JSON.stringify(params))
            }
        } else {
            fetch_conf.method = 'GET'
            const str = to_querystring.stringify(params)
            if (str != "") {
                this_url += '?' + str
            }
        }
        return fetch(this_url, fetch_conf).then(function (response) {
          if (response.status === 422 && extra_options.refresh_if_422 === true) {
            window.location.reload();
            return;
          }
          return response.json()
        })
    }
}

export default DataFetch
